module.exports = __webpack_public_path__ + "img/kehu_03.3180af09.png";